import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
/**
 * Champ adresse d'une fiche annuaire : la rue seule, le code postal et la
 * ville de la commune étant ajoutés côté backend pour placer la fiche sur la carte.
 */
export function AddressField({ value, onChange, postalCode, city }) {
    const commune = [postalCode, city].filter(Boolean).join(' ');
    return (_jsxs("div", { children: [_jsx("label", { htmlFor: "address", className: "block text-sm font-medium text-gray-700 mb-1", children: "Adresse (rue uniquement)" }), _jsx("input", { id: "address", value: value, onChange: onChange, placeholder: "Ex. 12 rue de la Mairie", "aria-describedby": "address-hint", className: "w-full px-3 py-2 border rounded-lg text-sm" }), _jsx("p", { id: "address-hint", className: "text-xs text-gray-500 mt-1", children: commune
                    ? `Le code postal et la ville (${commune}) sont ajoutés automatiquement.`
                    : 'Le code postal et la ville sont ajoutés automatiquement.' })] }));
}
